import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-slate-500">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Guard 1: route réservée à un rôle spécifique (ex: super_admin)
  if (role && user.role !== role) {
    // Un utilisateur agence qui tape /superadmin → renvoyé vers l'espace agence
    return <Navigate to="/app" replace />;
  }
  // Guard 2: le super_admin ne doit JAMAIS accéder à l'espace agence /app/*
  if (!role && user.role === "super_admin") {
    return <Navigate to="/superadmin" replace />;
  }
  return children;
}
